import { render, staticRenderFns } from "./ModalProfilingRules.vue?vue&type=template&id=3b551a6a&scoped=true&lang=pug"
import script from "./ModalProfilingRules.vue?vue&type=script&lang=js"
export * from "./ModalProfilingRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b551a6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b551a6a')) {
      api.createRecord('3b551a6a', component.options)
    } else {
      api.reload('3b551a6a', component.options)
    }
    module.hot.accept("./ModalProfilingRules.vue?vue&type=template&id=3b551a6a&scoped=true&lang=pug", function () {
      api.rerender('3b551a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profiling/ModalProfilingRules.vue"
export default component.exports